<template>
  <!-- page content -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-8 col-md-10 col-sm-12 mx-auto user-panel mt-5 mb-5">
        <h4 class="actionable" @click="$router.go(-1)">
          <i class="fa fa-arrow-circle-o-left" style="padding-right: 2px;"></i>
          Back
        </h4>

        <h3 style="margin-top: 40px; margin-bottom: 20px;">Change Log</h3>

        <div class="card" v-for="version in versions">
          <div class="card-header">
            {{ version.version }} - {{ version.author }}

            <span class="pull-right">{{
              version.created_at | displayLocalDateTime
            }}</span>
          </div>
          <div class="card-block">
            <p class="card-text">{{ version.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from "../../config";
import { mapState, mapGetters } from "vuex";
import { EventBus } from "../../utils/events";
import moment from "moment";

export default {
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      versions: {}
    };
  },
  mounted() {
    this.getVersionHistory();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getVersionHistory() {
      var _this = this;
      this.$http
        .get(Config.apiPath + "/api/v2/utilities/versions")
        .then(response => {
          _this.versions = response.data.data;
        });
    }
  },

  filters: {
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm A");
    }
  }
};
</script>

<style scoped>
body {
  background-color: #eff1f3;
}

.h-100 {
  min-height: 100vh;
}

.container-fluid {
  height: 100%;
}

.card {
  margin-bottom: 20px;
}

.card-block {
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

a:hover {
  text-decoration: none;
}

.actionable {
  color: #007bff;
  cursor: pointer;
}
</style>
